import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';

import { PscPhrase } from '../../components/psc/psc-phrase';
import SingleSelect from '../../components/psc/lib/SingleSelect'

const ReportSchemeBulkSelectModal = ({ items, section, bulkAdd, show, onHide }) => {
    const [ selectedItem, setSelectedItem ] = useState(0)
    const [ selectedItemOptions, setSelectedItemOptions ] = useState([])
    const [ searchTerm, setSearchTerm ] = useState('')
    const filteredOptions = selectedItemOptions
        .filter((option) => option.name.toLowerCase().includes(searchTerm))
    const allChecked = filteredOptions.length && filteredOptions.every(option => option.checked)
    const allCheckedLabel = searchTerm ? PscPhrase('SELECT_ALL_IN_SEARCH') : PscPhrase('SELECT_ALL')
    const itemOptions = items.map(item => ({
        id: item.id,
        name: item.name,
        label: item.label,
        value: item.value
    }))

    const onItemSelect = (event) => {
        const itemName = event.name
        const item = items.find(({ name }) => name === itemName)
        setSelectedItem(item.id)
        setSelectedItemOptions(item.options)
    }

    const onCheckDocumentType = (event) => {
        const documentTypeId = Number(event.target.value);

        const updatedOptions = selectedItemOptions
            .map((option) => {
                const isChecked = !!option.checked
                return {
                    ...option,
                    checked: option.id === documentTypeId ? !isChecked : isChecked,
                }
            })

        setSelectedItemOptions(updatedOptions)
    }

    const onCheckAllDocumentTypes = () => {
        const shouldCheckAll = !allChecked

        const updatedOptions = selectedItemOptions
            .map((option) => {
                const optionIsVisible = filteredOptions.map(({ id }) => id).includes(option.id)
                return { ...option, checked: optionIsVisible ? shouldCheckAll : option.checked }
            })

        setSelectedItemOptions(updatedOptions)
    }

    const onFilterDocumentTypes = (event) => {
        setSearchTerm(event.target.value.toLowerCase())
    }

    const resetModalValues = () => {
        setSelectedItem()
        setSelectedItemOptions([])
        setSearchTerm('')
    }

    const onSubmit = () => {
        const usages = selectedItemOptions.filter(option => !!option.checked)

        bulkAdd(usages, section)
        onHide()
        resetModalValues()
    }

    return (
        <Modal size="lg" show={show} onHide={onHide}>
            <Modal.Header closeButton>
                <Modal.Title className="text-center full-width">
                    <i  style={{fontSize: '84px', color: '#e2e3e3'}} className="fa fa-files-o" />
                    <h4 style={{fontSize: '28px'}}>Add Several Document Types to a Report Section</h4>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="form-group">
                    <p>
                        Report Section
                    </p>

                    <input className="input-sm form-control input-s-sm" type="text" value={section.title} disabled={true} />

                    <p>
                        &nbsp;
                    </p>

                    <p>
                        Configured Item
                    </p>

                    <SingleSelect
                        name="object_type"
                        value={selectedItem}
                        onChange={event => onItemSelect(event)}
                        options={itemOptions}
                        disabled={selectedItemOptions.some(option => !!option.checked)}
                    />

                    {selectedItem ?
                        <div style={{ marginTop: 20 }}>
                            <p>Select all Document Types that will use this Template</p>

                            <input type="text" className="input-sm form-control input-s-sm inline" onChange={onFilterDocumentTypes} value={searchTerm} placeholder="Search.."/>
                            <label style={{ display: 'inline-flex', marginTop: 5 }}>
                                <input style={{ margin: '0 5px' }} type="checkbox" onChange={onCheckAllDocumentTypes} checked={allChecked} />
                                {allCheckedLabel}
                            </label>

                            <div style={{overflow: 'auto', height: 250}}>
                                <table>
                                    <tbody>
                                        {filteredOptions.map((option) => (
                                            <tr key={option.id}>
                                                <td>
                                                    <label style={{ display: 'inline-flex', marginTop: 5 }}>
                                                        <input style={{ margin: '0 5px' }} type="checkbox" checked={!!option.checked} value={option.id} onChange={onCheckDocumentType} />
                                                        {option.name}
                                                    </label>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        : null}
                </div>
                <Modal.Footer>
                    <button type="button" className="btn btn-mr btn-white" data-dismiss="modal" onClick={resetModalValues}>Close</button>
                    <button type="button" className="btn btn-mr btn-primary" onClick={onSubmit}>OK</button>
                </Modal.Footer>
            </Modal.Body>
        </Modal>
    )
};

export default ReportSchemeBulkSelectModal
